import { useRouter, useUserInfo } from '@/hooks/hooks';
import { Link } from 'react-router-dom';
import style from '../style/FrontLayout.module.less';
import {hasPermission} from '@/utils';

const getMenu = () => {
  const menuList = [
    {
      name: '考试分析',
      description: '创建考试、导入成绩等',
      imgSrc: 'exam-center',
      path: '/front/examCenter',
      code: 'EXAM'
    },
    // {
    //   name: '学情分析',
    //   description: '查看联考分析报表',
    //   imgSrc: 'style-analysis'
    // },
    {
      name: '校务管理',
      description: '班级管理、教师管理、学生管理',
      imgSrc: 'school-mana',
      path: '/front/school',
      code: 'SCHOOL'
    },
    {
      name: '人员管理',
      onlyEdu: true,
      description: '管理教育局人员等',
      imgSrc: 'research-mana',
      path: '/front/personnel',
      code: 'USER'
    },
    {
      name: '权限管理',
      onlyEdu: true,
      description: '管理教育局人员的权限',
      imgSrc: 'permission-mana',
      path: '/front/permission',
      code: 'AUTHORITY'
    },
    {
      name: '报告分析模板',
      onlyEdu: true,
      description: '报告分析模板配置',
      imgSrc: 'report-template',
      path: '/front/template',
      code: 'REPORT_TEMPLATE'
    }
  ];
  return menuList;
};

interface FrontMeunProps {
  userType: 'EDU' | 'TEACHER' | 'ADMIN'
}

const FrontMeun: React.FC<FrontMeunProps> = props => {

  const user = useUserInfo();
  const router = useRouter();

  function getMenuList (userType: FrontMeunProps['userType']) {
    const menuList = getMenu();
    const exam = menuList.find(i => i.name === '考试分析');
    const school = menuList.find(i => i.name === '校务管理');
    // 依据用户角色跳转不同的校务管理
    if (exam) {
      exam.description = props.userType === 'EDU' ? '创建考试、导入成绩、查看分析等' : '缺考学生标记、查看分析';
    }
    if (school && userType === 'TEACHER') {
      const { id, schoolgradeDcode } = user.currentSchool;
      const teacherPath = router.encodeParams(id + '+校务管理') + '?gradeDcode=' + schoolgradeDcode;
      school.path = props.userType === 'EDU' ? '/front/school' : `/front/${teacherPath}`;
    }
    if (userType === 'EDU') {
      // 教育局人员
      return menuList.filter(i => hasPermission(i.code));
    } else {
      // 教师用户
      return menuList.filter(i => !i.onlyEdu);
    }
  }

  return (
    <div
      className={style.frontMenu}
      style={{
        gridTemplateRows: `repeat(${Math.ceil(getMenuList(props.userType).length / 3)}, 182px)`
      }}
    >
      {
        getMenuList(props.userType).map(i => (
          <Link key={i.name} to={i.path || '/'}>
            <img src={require('@/assets/imgs/frontMenu/' + i.imgSrc + '.png')} alt="" />
            <div className={style.menuName}>{i.name}</div>
            <div className={style.menuDescription}>{i.description}</div>
          </Link>
        ))
      }
      <a href='#'>
        {/* <img src={require('@/assets/imgs/frontMenu/report-template.png')} alt="" /> */}
        <div className={style.fakeImg}><span>···</span></div>
        <div className={style.menuName}></div>
        <div className={style.more}>更多内容，敬请期待</div>
      </a>
    </div>
  );
};

export default FrontMeun;
